/*
* Association amenity responsibilities form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsAmenityResponsibilitiesInterior = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const inputPropsCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 7,
        colInputXs: 5,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <Row>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.interiorLighting"
                            label={appText('interior-lighting')}
                            value={formData.details.interiorLighting}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.interiorPainting"
                            label={appText('interior-painting')}
                            value={formData.details.interiorPainting}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.interiorFloors"
                            label={appText('interior-flooring')}
                            value={formData.details.interiorFloors}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.office"
                            label={appText('office')}
                            value={formData.details.office}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.laundryEquipment"
                            label={appText('laundry-equipment')}
                            value={formData.details.laundryEquipment}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.interiorElevators"
                            label={appText('interior-elevators')}
                            value={formData.details.interiorElevators}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.kitchen"
                            label={appText('kitchen')}
                            value={formData.details.kitchen}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.gym"
                            label={appText('gym')}
                            value={formData.details.gym}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.restrooms"
                            label={appText('restrooms')}
                            value={formData.details.restrooms}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
            </Row>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-amenity-responsibilities-interior.tsx